import script from "./add-invoice.vue?vue&type=script&setup=true&lang=js"
export * from "./add-invoice.vue?vue&type=script&setup=true&lang=js"

import "./add-invoice.vue?vue&type=style&index=0&id=010691ea&lang=css"

const __exports__ = script;

export default __exports__